// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__38Pod","inputDescription":"styles_inputDescription__10uQJ"};